module.exports = __webpack_public_path__ + "media/illustrations/treats--white-fill-2a6b012e.svg";